/**
 * PIN-Hashing — bewusst NICHT kryptografisch (FNV-1a, 32-bit).
 *
 * Grund: Auf dem Handy über http://<LAN-IP> gibt es keinen secure context, also keine
 * Web-Crypto-API. Der PIN ist hier ein Verwechslungs-/Zugriffsschutz unter Personal,
 * keine echte Sicherheit. Funktioniert offline und in jedem Kontext. Mit HTTPS später
 * auf ein echtes Verfahren (z. B. PBKDF2) umstellbar.
 */
export function hashPin(pin: string): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < pin.length; i++) {
    h ^= pin.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return (h >>> 0).toString(16).padStart(8, "0");
}

export function verifyPin(pin: string, pinHash: string): boolean {
  return hashPin(pin) === pinHash;
}

/**
 * PIN aus dem Hash zurückrechnen ("PIN anzeigen" in Admin-Konsole/Kundenportal). Möglich
 * und bewusst zulässig, WEIL der Hash oben explizit kein echter Schutz ist (s. Kommentar) —
 * PINs sind numerisch bis 6 Stellen (UI-Konvention), das sind max. 1.111.110 Kandidaten,
 * eine simple Suche ist sofort fertig. Gibt null zurück, wenn keine Ziffernfolge bis 6
 * Stellen passt (z. B. eine außerhalb der üblichen UI gesetzte PIN).
 */
export function revealPin(pinHash: string): string | null {
  for (let len = 1; len <= 6; len++) {
    const max = 10 ** len;
    for (let n = 0; n < max; n++) {
      const candidate = String(n).padStart(len, "0");
      if (hashPin(candidate) === pinHash) return candidate;
    }
  }
  return null;
}
